/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ReceiptPrintCheckbox/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function ReceiptPrintCheckbox({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content/ReceiptPrintCheckbox",
  onChange,
  isSubmitting
  
}) {
let paymentsPostPaymentReceiptCheckboxPrintValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'receipt.checkbox.print',
})
let paymentsPostPaymentReceiptCheckboxPrintChangeData = fromData.useDataChange({ viewPath,
context: 'payments_post_payment',
path: 'receipt.checkbox.print',
})
let paymentsPostPaymentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payments_post_payment',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginTop={0}
 data="payments_post_payment.receipt.checkbox.print"
 value={paymentsPostPaymentReceiptCheckboxPrintValueData}
 onChange={paymentsPostPaymentReceiptCheckboxPrintChangeData}
 data="payments_post_payment"
 disabled={paymentsPostPaymentIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
 backgroundColor="white"
 borderColor={dtColorsNeutral300}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Print"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}